import { QueryFunctionContext } from '@tanstack/react-query';

import { RelevanceTestsService } from 'src/services/RelevanceTestsService';

export const QUERY_KEY = 'relevance_test_definition';

export const queryRelevanceTestDefinition = (
    context: QueryFunctionContext<App.RelevanceTestDefinitions.DefinitionLookupQueryKey, number>,
): Promise<Models.IngestConfigApi.RelevanceTests.RelevanceTestDefinition> => {
    const { queryKey } = context;
    const [, accessToken, search] = queryKey;

    return RelevanceTestsService.getRelevanceTestDefinition(
        accessToken,
        search,
    );
};
